import React from "react"

import PropTypes from "prop-types"
import {Provider} from "react-redux"
import {BrowserRouter, Route, Routes} from "react-router-dom"

import {Page} from "./constants/page/pages"
import {PagesArchitecture} from "./constants/page/pagesArchitecture"
import {AsyncTechnicalErrorScene} from "./layouts/asyncScenes"
import MainLayoutContainer from "./layouts/mainLayout"
import {MatomoTracker} from "./shared-components/components/MatomoTracker/matomoTracker"
import TextsProvider from "./shared-components/components/TextsProvider/textsProvider"
import injectTexts from "./shared-components/styles/injectTexts"
import {getCookiesChoices} from "./store/selectors/localStorage/cookiesSelectors"
import texts from "./styles/globalText"
import StyleLoaderLayout from "./layouts/styleLoaderLayout"
import NavigationInitializer from "./shared-components/services/navigate"
/**
 * Root of the application.
 * Set the provider to distribute the store in all components.
 * Set the router root.
 */
const Root = ({store, texts}) => (
    <Provider store={store}>
        <MatomoTracker getCookiesChoices={getCookiesChoices}>
            <TextsProvider texts={texts}>
                <BrowserRouter>
                <NavigationInitializer />
                    <Routes>
                        <Route
                            element={AsyncTechnicalErrorScene}
                            path={PagesArchitecture[Page.TECHNICAL_ERROR].route}
                        />
                        <Route
                            element={
                                <StyleLoaderLayout>
                                    <MainLayoutContainer />
                                </StyleLoaderLayout>
                            }
                            path="/*"
                        />
                    </Routes>
                </BrowserRouter>
            </TextsProvider>
        </MatomoTracker>
    </Provider>
)

Root.propTypes = {
    sheet: PropTypes.object.isRequired,
    store: PropTypes.object.isRequired,
    texts: PropTypes.object.isRequired,
}

export default injectTexts(texts, Root)
